export const ThinkingIcon = () => (
  <span className="material-symbols-outlined text-[#0096D4] !text-5xl">psychology_alt</span>
);